import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MailX, Coffee } from "lucide-react";
import { api } from "@/lib/api";

export default function UnsubscribePage() {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | done | error

  useEffect(() => {
    api
      .post(`/unsubscribe/${token}`)
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <main data-testid="unsubscribe-page" className="mx-auto max-w-xl px-6 py-28 text-center">
      {state === "loading" && <p className="text-sm text-[#F7F1E8]/68">O clipă&hellip;</p>}
      {state === "done" && (
        <>
          <MailX className="mx-auto h-10 w-10 text-[var(--accent)]" strokeWidth={1.4} />
          <h1 className="mt-6 font-serif text-4xl font-light text-[#F7F1E8]" data-testid="unsubscribe-done">
            Te-am dezabonat.
          </h1>
          <p className="mt-4 text-[15px] leading-relaxed text-[#F7F1E8]/78">
            Nu vei mai primi însemnările pe email. Ești oricând binevenit(ă) înapoi — cu sau fără abonare,
            ușa clasei rămâne deschisă.
          </p>
        </>
      )}
      {state === "error" && (
        <>
          <Coffee className="mx-auto h-10 w-10 text-[var(--sun)]" strokeWidth={1.4} />
          <h1 className="mt-6 font-serif text-4xl font-light text-[#F7F1E8]" data-testid="unsubscribe-error">
            Linkul nu mai este valabil.
          </h1>
          <p className="mt-4 text-[15px] leading-relaxed text-[#F7F1E8]/78">
            Probabil te-ai dezabonat deja sau linkul este greșit.
          </p>
        </>
      )}
      <Link
        to="/"
        data-testid="unsubscribe-home-link"
        className="mt-10 inline-flex rounded-full bg-[var(--accent)] px-6 py-3 text-xs font-medium uppercase tracking-[0.2em] text-white transition-transform hover:-translate-y-0.5"
      >
        Înapoi la însemnări
      </Link>
    </main>
  );
}
